import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import MyQuoteService from '@/service/MyQuoteService';
import UploadImageService from '@/service/UploadImageService';

export const useMyQuoteStore = defineStore('myQuoteStore', {
  state: () => {
    return {
      statistic: {},
      noteList: [],
      reminderList: []
    };
  },
  getters: {
    getUrlUploadImg: () => {
      const Service = new UploadImageService();
      return Service.urlImage;
    },
    getUrlUploadFile: () => {
      const Service = new UploadImageService();
      return Service.urlFile;
    }
  },
  actions: {
    findNewReminders() {
      return this.findReminders('NEW');
    },
    findCompletedReminders() {
      return this.findReminders('COMPLETED');
    },
    findReminders(filter: string) {
      return this.reminderList?.length ? this.reminderList.filter((item) => item.sts === filter) : [];
    },
    async getStatistic(email: string) {
      const Service = new MyQuoteService();
      const res = await Service.getStatistic(email);
      this.statistic = res?.data;
    },
    async getReminders(payload) {
      const Service = new MyQuoteService();
      const res = await Service.getReminders(payload);
      this.reminderList = res?.data.reverse();
    },
    async addReminder(payload) {
      const Service = new MyQuoteService();
      const res = await Service.addReminder(payload);
      this.reminderList = res?.data;
    },
    async updateReminder(payload) {
      const Service = new MyQuoteService();
      const res = await Service.updateReminder(payload);
      return res?.data;
    },
    async deleteReminder(id) {
      const Service = new MyQuoteService();
      const res = await Service.deleteReminder(id);
      return res?.data;
    },
    async getNote(quoteId) {
      const Service = new MyQuoteService();
      const res = await Service.getNote(quoteId);
      this.noteList = res?.data;
    },
    async addNote(quoteId, payload) {
      const Service = new MyQuoteService();
      const res = await Service.addNote(quoteId, payload);
      return res?.data;
    },
    async updateNote(quoteId, noteList, isAgent, role) {
      const service = new MyQuoteService();
      try {
        await service.updateNote(quoteId, noteList, isAgent, role);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getListQuotes(email, role, payload) {
      const Service = new MyQuoteService();
      const res = await Service.getListQuotes(role, payload);
      return res?.data;
    }
  }
});
